import React, { useState } from 'react';
import { Accordion, Button, Form, FormCheckbox, FormGroup, Icon, Modal, Segment, Table } from 'semantic-ui-react';
import { useTranslation, withTranslation } from 'react-i18next';

const filterTypes = {
    UNATTEMPTED: "UNATTEMPTED",
    ATTEMPTED: "ATTEMPTED",
    FLAGGED: "FLAGGED",
    WRONG: "WRONG",
    CORRECT: "CORRECT"
};

const ExamSummary = ({ questions, onSelectQuestion, onFlagQuestion, summary, isMockExam, theme, isViewOnly }) => {
    const { t, i18n } = useTranslation();
    const isArabic = i18n.language === 'ar';
    const [filters, setFilters] = useState([]);
    const [activeIndex, setActiveIndex] = useState(0);
    const [showExplainedScreen, setShowExplainedScreen] = useState(false);

    const buttonStyle = {
        boxShadow: 'none !important',
        borderRadius: 0,
        borderLeft: isArabic ? 'solid white' : 'none',
        borderRight: !isArabic ? 'solid white' : 'none',
        backgroundColor: 'transparent',
        color: 'black'
    };

    const handleAccordion = (e, titleProps) => {
        const { index } = titleProps;
        const newIndex = activeIndex === index ? -1 : index;
        setActiveIndex(newIndex);
    };

    const printQuestionState = (q) => {
        if (!q.answerText && !q.answerOptionId && !q.answerJson) return t('NotAnsweredQuestion');
        if (q.answerOptionId && q.correctAnswer && !isMockExam && q.correctAnswer.correctAnswerOptionId === q.answerOptionId)
            return t('CorrectAnswer');
        else if (q.answerOptionId && q.correctAnswer && !isMockExam && q.correctAnswer.correctAnswerOptionId !== q.answerOptionId)
            return t('WrongAnswer');
        else if (q.answerOptionId && !q.correctAnswer && !isMockExam)
            return t('ClickToLoadQuestion');
        return t('Answered');
    };

    const handleChange = (value) => {
        if (filters.includes(value)) return setFilters(prev => prev.filter(f => f !== value));
        return setFilters(prev => [...prev, value]);
    };

    return (
        <div>
            <div className='tw-bg-[#f2f2f2] tw-flex tw-flex-row tw-items-center tw-px-3 tw-mb-5'>
                <Button onClick={() => setShowExplainedScreen(true)} content={t("ItemReviewScreenExplained")} style={buttonStyle} icon="comment alternate outline" labelPosition='left' />
            </div>

            <div className='tw-bg-[#f2f2f2]'>
                <Accordion>
                    <Accordion.Title active={activeIndex === 0} index={0} onClick={handleAccordion}>
                        <div className='tw-mx-5 tw-flex tw-flex-row tw-items-center tw-gap-5'>
                            <div><Icon name={activeIndex === 0 ? "minus square outline" : "plus square outline"} /></div>
                            <p>{t("ExamSection")}</p>
                        </div>
                    </Accordion.Title>

                    <Accordion.Content active={activeIndex === 0}>
                        <Segment basic>
                            <Form>
                                <FormGroup inline>
                                    <label>{t("FilterBy")}</label>
                                    <FormCheckbox
                                        label={t("NotAttempted")}
                                        value={filterTypes.UNATTEMPTED}
                                        checked={filters.includes(filterTypes.UNATTEMPTED)}
                                        onChange={() => handleChange(filterTypes.UNATTEMPTED)}
                                    />
                                    {(isViewOnly) && <FormCheckbox
                                        label={t("Wrong")}
                                        value={filterTypes.WRONG}
                                        checked={filters.includes(filterTypes.WRONG)}
                                        onChange={() => handleChange(filterTypes.WRONG)}
                                    />}
                                    <FormCheckbox
                                        label={t("Attempted")}
                                        value={filterTypes.ATTEMPTED}
                                        checked={filters.includes(filterTypes.ATTEMPTED)}
                                        onChange={() => handleChange(filterTypes.ATTEMPTED)}
                                    />
                                    <FormCheckbox
                                        label={t("Flagged")}
                                        value={filterTypes.FLAGGED}
                                        checked={filters.includes(filterTypes.FLAGGED)}
                                        onChange={() => handleChange(filterTypes.FLAGGED)}
                                    />
                                    {(isViewOnly) && <FormCheckbox
                                        label={t("Correct")}
                                        value={filterTypes.CORRECT}
                                        checked={filters.includes(filterTypes.CORRECT)}
                                        onChange={() => handleChange(filterTypes.CORRECT)}
                                    />}
                                    {filters.length > 0 && <label className='tw-cursor-pointer' onClick={() => setFilters([])}>{t("Clear")}</label>}
                                </FormGroup>
                            </Form>

                            <Table celled unstackable compact>
                                <Table.Body>
                                    {
                                        questions.filter(q => !(q?.showFactOnly)).map((q, indx) => {
                                            const isFlagged = q.isFlagged;
                                            const isAttempted = q?.answerOptionId || q?.answerText || q?.answerJson;
                                            const isUnAttempted = !isAttempted;
                                            const isCorrect = (isViewOnly) && q?.isPassed;
                                            const isWrongAnswerd = (isViewOnly) && isAttempted && q?.isPassed === 0;
                                            const questionStatus = [];

                                            isFlagged && questionStatus.push(filterTypes.FLAGGED);
                                            isAttempted && questionStatus.push(filterTypes.ATTEMPTED);
                                            isUnAttempted && questionStatus.push(filterTypes.UNATTEMPTED);
                                            isWrongAnswerd && questionStatus.push(filterTypes.WRONG);
                                            isCorrect && questionStatus.push(filterTypes.CORRECT);

                                            if (filters.length === 0 || filters.every(f => questionStatus.includes(f)))

                                                return <Table.Row
                                                    key={q.questionId}
                                                    style={{ cursor: 'pointer' }}
                                                >
                                                    <Table.Cell collapsing>
                                                        <Icon link name='flag' onClick={() => onFlagQuestion(q)} style={{ color: q.isFlagged ? 'red' : '#ddd' }} />
                                                    </Table.Cell>

                                                    <Table.Cell
                                                        onClick={() => {
                                                            onSelectQuestion(q);
                                                            if (window.ExamNav)
                                                                window.ExamNav.goTo(Number(indx));
                                                            summary.setShowSummary(false);
                                                        }}
                                                    >
                                                        {`${t('Question')} ${indx + 1}`}
                                                    </Table.Cell>

                                                    <Table.Cell>
                                                        <p className='tw-font-bold' style={{ color: isCorrect ? "green" : "red" }}> {printQuestionState(q)}</p>
                                                    </Table.Cell>
                                                </Table.Row>;
                                            else return null;
                                        })
                                    }
                                </Table.Body>
                            </Table>
                        </Segment>
                    </Accordion.Content>
                </Accordion>
            </div>


            <Modal
                size='large'
                open={showExplainedScreen}
                header={<div className='tw-p-3 tw-bg-[#dcdddd]'><p>{t('ItemReviewScreen')}</p></div>}
                content={<div className='tw-bg-[#dcdddd] tw-p-5'>
                    <div className='tw-flex tw-flex-row tw-gap-5'>
                        <div><Icon name='exclamation circle' size='big' /></div>
                        <div className='tw-space-y-4'>
                            <p>{t("ItemReviewScreenText1")}</p>
                            <ul className='tw-list-disc tw-mx-5 tw-space-y-2'>
                                <li>{t("ItemReviewScreenText2")}</li>
                                <li>{t("ItemReviewScreenText3")}</li>
                                <li>{t("ItemReviewScreenText4")}</li>
                            </ul>
                            <p>{t("ItemReviewScreenText5")}</p>
                            <p>{t("ItemReviewScreenText6")}</p>
                            <p>{t("ItemReviewScreenText7")}</p>
                            <p>{t("ItemReviewScreenText8")}</p>
                        </div>
                    </div>
                    <div className='tw-my-5 tw-flex tw-flex-row tw-justify-center'>
                        <Button onClick={() => setShowExplainedScreen(false)} content={t("Close")} />
                    </div>
                </div>}
            />
        </div>

    );
};

export default withTranslation()(ExamSummary);